function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import haunted, { component as hauntedComponent, virtual as hauntedVirtual } from 'haunted';
import { t } from '@process-creative/slate-theme-tools';
import { TemplateResult } from 'lit-html';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import $ from 'jquery';
export * from 'lit-html';
export * from 'lit-html/directives/unsafe-html';
export * from 'lit-html/directives/live';
export * from 'lit-html/directives/style-map';
export * from 'haunted'; //A fully rendered component

//Short hand methods
export var unsafeTranslate = function unsafeTranslate(key, variables) {
  return unsafeHTML(t(key, variables));
}; //Event Listener using jQuery events (Deprecated)

/**
 * @deprecated
 */

export var componentAddEventListener = function componentAddEventListener(s, cb) {
  var _callback;

  _callback = function callback() {
    $(document).off(s, _callback);
    cb.apply(void 0, arguments);
  };

  return $(document).on(s, _callback);
};
/**
 * Component Wrapper, used to help manage components easier as the spec is still
 * being fleshed out
 */

export var component = function component(params, hauntedParams) {
  //In order to stop a double definition of components, we're going to manage
  //created components here. It seems that lit can't do this for us.
  //@ts-ignore
  var ec = window.pcComponents = window.pcComponents || {}; //@ts-ignore

  window.pcComponents = ec;
  var existingComponents = ec;

  if (existingComponents[params.name]) {
    return existingComponents[params.name];
  } //Component doesn't exist, let's create it


  var compHaunted = hauntedComponent(params.render, _objectSpread({
    useShadowDOM: false,
    observedAttributes: params.attributes || []
  }, hauntedParams || {})); //@ts-ignore

  customElements.define(params.name, compHaunted);

  var comp = _objectSpread(_objectSpread({}, params), {}, {
    create: function create(props) {
      var element = new compHaunted(props);

      if (props) {
        Object.keys(props).forEach(function (k) {
          var v = props[k];
          if (!v) return;
          element.setAttribute(k, v);
        });
      } //Custom inner HTML


      var innerHTML = '';
      Object.defineProperty(element, 'innerHTML', {
        get: function get() {
          return innerHTML;
        },
        set: function set(value) {
          innerHTML = value;
        }
      });
      var clz = params.class;
      if (clz) (Array.isArray(clz) ? clz : [clz]).forEach(function (c) {
        return element.classList.add(c);
      });
      return element;
    }
  }); //Store the component so it's not created twice in future.


  existingComponents[params.name] = comp;
  return comp;
};
/**
 * Type of a virtualized component.
 */

/**
 * Create a virtual component for a functional component.
 * @param component
 * @return The virtually wrapped component
 */
export var virtual = function virtual(component) {
  return hauntedVirtual(component);
};